"use strict";
/// <reference path='../../../node_modules/@walletconnect/types-v1/index.d.ts' />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectWallet = void 0;
var base_1 = require("@celo/base");
var wallet_remote_1 = require("@celo/wallet-remote");
var client_v1_1 = __importDefault(require("@walletconnect/client-v1"));
var debug_1 = __importDefault(require("debug"));
var constants_1 = require("./constants");
var types_1 = require("./types");
var wc_signer_1 = require("./wc-signer");
var debug = (0, debug_1.default)('kit:wallet:wallet-connect-wallet-v1');
/**
 * Session establishment happens out of band so after somehow
 * communicating the connection URI (often via QR code) we can
 * continue with the setup process
 */
function waitForTruthy(getValue, attempts) {
    if (attempts === void 0) { attempts = 10; }
    return __awaiter(this, void 0, void 0, function () {
        var waitDuration, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    waitDuration = 500;
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < attempts)) return [3 /*break*/, 4];
                    if (getValue()) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, (0, base_1.sleep)(waitDuration)];
                case 2:
                    _a.sent();
                    waitDuration = waitDuration * 1.5;
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: throw new Error('Unable to get pairing session, did you lose internet connection?');
            }
        });
    });
}
var defaultInitOptions = {
    bridge: constants_1.defaultBridge,
    clientMeta: {
        name: 'ContractKit',
        description: "Celo's ContractKit is a library to help developers and validators to interact with the celo-blockchain.",
        url: 'https://github.com/celo-org/celo-monorepo/tree/master/packages/sdk/contractkit',
        icons: [],
    },
};
var defaultConnectOptions = {
    chainId: 42220, // Celo Mainnet
};
var WalletConnectWallet = /** @class */ (function (_super) {
    __extends(WalletConnectWallet, _super);
    function WalletConnectWallet(_a) {
        var init = _a.init, connect = _a.connect;
        var _this = _super.call(this) || this;
        _this.onSessionCreated = function (error, session) {
            debug('onSessionCreated', error, session);
            if (error) {
                throw error;
            }
        };
        _this.onSessionDeleted = function (error, session) {
            debug('onSessionDeleted', error);
            if (error) {
                throw error;
            }
            if (session.event === 'disconnect') {
                var params = session.params;
                var error_1 = params && params[0] && params[0].message
                    ? params[0].message
                    : 'Unknown error';
                void _this.close(error_1);
            }
        };
        _this.onSessionRequest = function (error, session) {
            debug('onSessionRequest', error, session);
            if (error) {
                throw error;
            }
        };
        _this.onSessionUpdated = function (error, session) {
            debug('onSessionUpdated', error, session);
            if (error) {
                throw error;
            }
        };
        _this.onCallRequest = function (error, payload) {
            debug('onCallRequest', error, payload);
            if (error) {
                throw error;
            }
        };
        _this.onWcSessionRequest = function (error, payload) {
            debug('onWcSessionRequest', error, payload);
            if (error) {
                throw error;
            }
        };
        _this.onWcSessionUpdate = function (error, payload) {
            debug('onWcSessionUpdate', error, payload);
            if (error) {
                throw error;
            }
        };
        _this.initOptions = __assign(__assign({}, defaultInitOptions), init);
        _this.connectOptions = __assign(__assign({}, defaultConnectOptions), connect);
        return _this;
    }
    /**
     * Pulled out to allow mocking
     */
    WalletConnectWallet.prototype.getWalletConnectClient = function () {
        return new client_v1_1.default(this.initOptions);
    };
    /**
     * Get the URI needed for out of band session establishment
     */
    WalletConnectWallet.prototype.getUri = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.client = this.getWalletConnectClient();
                        this.client.on(types_1.CLIENT_EVENTS.connect, this.onSessionCreated);
                        this.client.on(types_1.CLIENT_EVENTS.disconnect, this.onSessionDeleted);
                        this.client.on(types_1.CLIENT_EVENTS.session_request, this.onSessionRequest);
                        this.client.on(types_1.CLIENT_EVENTS.session_update, this.onSessionUpdated);
                        this.client.on(types_1.CLIENT_EVENTS.call_request, this.onCallRequest);
                        this.client.on(types_1.CLIENT_EVENTS.wc_sessionRequest, this.onWcSessionRequest);
                        this.client.on(types_1.CLIENT_EVENTS.wc_sessionUpdate, this.onWcSessionUpdate);
                        if (!!this.client.connected) return [3 /*break*/, 2];
                        // create new session
                        return [4 /*yield*/, this.client.createSession(this.connectOptions)];
                    case 1:
                        // create new session
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, (_a = this.client) === null || _a === void 0 ? void 0 : _a.uri];
                }
            });
        });
    };
    WalletConnectWallet.prototype.loadAccountSigners = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var addressToSigner;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    /**
                     * Session establishment happens out of band so after somehow
                     * communicating the connection URI (often via QR code) we can
                     * continue with the setup process
                     */
                    return [4 /*yield*/, waitForTruthy(function () { var _a; return !!((_a = _this.client) === null || _a === void 0 ? void 0 : _a.connected); })];
                    case 1:
                        /**
                         * Session establishment happens out of band so after somehow
                         * communicating the connection URI (often via QR code) we can
                         * continue with the setup process
                         */
                        _b.sent();
                        addressToSigner = new Map();
                        (_a = this.client) === null || _a === void 0 ? void 0 : _a.session.accounts.forEach(function (address) {
                            var _a;
                            var signer = new wc_signer_1.WalletConnectSigner(_this.client, (_a = _this.client) === null || _a === void 0 ? void 0 : _a.session, address);
                            addressToSigner.set(address, signer);
                        });
                        return [2 /*return*/, addressToSigner];
                }
            });
        });
    };
    /**
     * Gets the signer based on the 'from' field in the tx body
     * @param txParams Transaction to sign
     * @dev overrides WalletBase.signTransaction
     */
    WalletConnectWallet.prototype.signTransaction = function (txParams) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var fromAddress, signer;
            return __generator(this, function (_b) {
                if (!txParams.from) {
                    throw new Error('txParams.from must be defined');
                }
                fromAddress = (_a = txParams.from) === null || _a === void 0 ? void 0 : _a.toString();
                signer = this.getSigner(fromAddress);
                return [2 /*return*/, signer.signRawTransaction(txParams)];
            });
        });
    };
    WalletConnectWallet.prototype.close = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.client) {
                            throw new Error('Wallet must be initialized before calling close()');
                        }
                        if (!this.client.connected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.client.killSession({ message: message })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return WalletConnectWallet;
}(wallet_remote_1.RemoteWallet));
exports.WalletConnectWallet = WalletConnectWallet;
//# sourceMappingURL=wc-wallet.js.map